import React from 'react';
import { SectionTitle, SectionTitleProps } from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './SectionTitleBlock.style';

export const SectionTitleBlock = (props: SectionTitleProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
    <SectionTitle {...props} />
  </BlockContainer>
);

export type { SectionTitleProps };
